
import { Options, Vue, Prop } from "vue-property-decorator";

@Options({})
export default class extends Vue {
  @Prop() private reqdata!: string;
}
